var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFb(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    className: "svg-with-fb",
    tabIndex: -1,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 17,
    cy: 18,
    rx: 20,
    ry: 18,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fb-bg",
    d: "M32 6.0004C32 2.8476 29.1536 0 26 0H2C-1.1536 0 -4 2.8476 -4 6.0004V29.9996C-4 33.1524 -1.1536 36 2.0004 36H14V22.4H9.6V16.4H14V14.0624C14 10.0308 17.0272 6.4 20.75 6.4H25.6V12.4H20.75C20.2192 12.4 19.6 13.0444 19.6 14.0096V16.4H25.6V22.4H19.6V36H26C29.1536 36 32 33.1524 32 29.9996V6.0004Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7897 31V20.0533H23.3263L23.8569 15.7859H19.7897V13.0618C19.7897 11.8266 20.1186 10.9849 21.8259 10.9849L24 10.984V7.16708C23.624 7.11633 22.3334 7 20.8313 7C17.6947 7 15.5473 8.98836 15.5473 12.6391V15.7859H12V20.0533H15.5473V31H19.7897Z",
    fill: "#777081"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 18,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFb);
export default __webpack_public_path__ + "static/media/fb.59b77ad9.svg";
export { ForwardRef as ReactComponent };